import gql from 'graphql-tag';

export const saveAccountsNotesMutation = gql`
  mutation saveAccountsNotes($input: SaveAccountsNotesInput!) {
    saveAccountsNotes(input: $input) {
      status
      notes
    }
  }
`;
